// 导入组件，组件必须声明 name
import MultiSelectPull from './src/MultiSelectPull.vue';
import MultiSelectBar from './src/MultiSelectBar.vue';
import MultiSelectDialog from './src/MultiSelectDialog.vue';
import MultiSelectPanel from './src/MultiSelectPanel.vue';
import MultiCascader from './src/MultiCascader.vue';
import SingleSelectPanel from './src/SingleSelectPanel.vue';
import SingleSelectDialog from './src/SingleSelectDialog.vue';
import SingleSelectBtn from './src/SingleSelectBtn.vue';


const components = [
    MultiSelectPull,
    MultiSelectBar,
    MultiSelectDialog,
    MultiSelectPanel,
    MultiCascader,
    SingleSelectPanel,
    SingleSelectDialog,
    SingleSelectBtn,
]

// 为组件提供 install 安装方法，供按需引入
components.forEach(component => {
    component.install = function (Vue) {
        Vue.component(component.name, component);
    };
})


// 默认导出组件
export default components;
